export default __webpack_public_path__ + "static/media/apple-store.71c7be39.png";